// @flow
import styled from "styled-components";
import { titleFont } from "../../_static/Typography";

import buildColor from "../../_static/ColorPalette";
import { buildText } from "../../_atom/Text";

export const TrackMasterPicksRowWrapper = styled.li`
  list-style-type: none;
  background-color: ${buildColor("white", "100")};
  padding: 12px 8px 16px;
  ${(props) => props.scratched && "padding-bottom: 12px"};
  box-sizing: border-box;

  &:not(:last-child) {
    border-bottom: 1px solid ${buildColor("blue", "100")};
  }
`;

export const TopSectionWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
`;

export const RunnerNumberWrapper = styled.span`
  min-width: 16px;
  height: 16px;
  display: block;
  overflow: hidden;
`;

export const Position = styled.span`
  font-family: ${titleFont};
  margin-right: 8px;
  display: inline-block;
  text-transform: uppercase;
`;

export const RunnerOdds = styled.strong`
  font-size: 12px;
  line-height: 16px;
  opacity: ${(props) => (props.scratched ? 0.5 : 1)};
`;

export const RunnerName = styled(
  buildText({
    tag: "strong",
    fontSize: 15,
    color: buildColor("grey", "900")
  })
)`
  font-family: ${titleFont};
  margin: 0 8px;
  text-transform: uppercase;
  text-decoration: ${(props) => (props.scratched ? "line-through" : "none")};
  opacity: ${(props) => (props.scratched ? 0.5 : 1)};
  flex: 1 1 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const InfoText = styled(
  buildText({
    tag: "p",
    fontSize: 12,
    color: buildColor("grey", "800")
  })
)`
  margin-top: 12px;
  line-height: 1.33;
`;
